import { AuthGuard } from 'src/app/core/auth/auth.guard'

import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { SaleCallbackComponent } from './callback/show.component'
import { SaleCheckoutShowComponent } from './checkout/show.component'
import { SaleShowComponent } from './show/show.component'
import { OperationsGuard } from '../operation/operations.guard'

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard, OperationsGuard],

    children: [
      {
        path: 'callback',
        component: SaleCallbackComponent,
        pathMatch: 'full'
      },
      {
        path: ':saleId',
        component: SaleShowComponent,
        pathMatch: 'full'
      },
      {
        path: ':saleId/checkout',
        component: SaleCheckoutShowComponent,
        pathMatch: 'full',
        data: { layout: { hidePendingSaleBlock: true, hideCartButton: true } }
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SaleRoutingModule {}
